import { UserNameCell } from "@/components";
import { Referral, User, UserRole } from "@/types";
import { capitalize } from "@mui/material";
import { FC } from "react";
import { Datagrid, FunctionField, List, Pagination } from "react-admin";
import { TopToolbar } from "../top-toolbar";
import { InvitesCountCell } from "../invites-count-cell";
import { formatUserRoleToName } from "@/utils";

const ReferralUsersList: FC = () => {
  return (
    <List<User>
      perPage={30}
      actions={<TopToolbar />}
      pagination={<Pagination rowsPerPageOptions={[10, 15, 30, 50]} />}
      sort={{ field: "status", order: "ASC" }}
      empty={<></>} // needn't empty list component
    >
      <Datagrid
        rowClick={"show"}
        bulkActionButtons={false}
        style={{ tableLayout: "fixed" }}
      >
        <UserNameCell
          label="Name"
          source="id"
          sortBy="firstName"
          sortable={false}
        />
        <FunctionField<Referral>
          sortable={false}
          label="Payment Status"
          render={({ paymentStatus }) => capitalize(paymentStatus)}
        />
        <FunctionField<Referral>
          sortable={false}
          label="Role"
          render={({ role }) => formatUserRoleToName(role)}
        />
        <InvitesCountCell
          label="Woman Referral"
          referralRole={UserRole.MUSE}
          sortable={false}
        />
        <InvitesCountCell
          label="Man Referral"
          referralRole={UserRole.ALPHA}
          sortable={false}
        />
      </Datagrid>
    </List>
  );
};

export { ReferralUsersList };
